import React, { useState } from "react";

import {
    LinearProgress,
    OutlinedInput,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody, TableContainer,
    Paper, Checkbox,
    TableCell, IconButton
} from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import AddIcon from '@material-ui/icons/Add';
import StudentService from "./Locality/Service/studentService"
import FeeService from "./Locality/Service/feeService"
import FeeMasterService from "./Locality/Service/feeMasterService"

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { FieldArray } from "formik";
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
    ResponsiveContainer,
    ComposedChart,
    AreaChart,
    LineChart,
    Line,
    Area,
    PieChart,
    Pie,
    Cell,
    YAxis,
    XAxis,
} from "recharts";
import mock from "./mock";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Add, Remove } from "@material-ui/icons";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
// Helper function to get ordinal suffix for numbers
const getOrdinalSuffix = (num) => {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
};

export default function Fee() {
    const tableHeaders = ['Academic Year', 'Class', 'Student Name', 'Total Fee', 'Installment Fee', 'Edit', 'Delete',
        // 'Add More'
    ];

    const classes = useStyles();
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    // const [feeMasterList, setFeeMasterList] = useState([]);

    const [age, setAge] = React.useState('');
    const [studentList, setStudentList] = useState([]);
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [feeList, setFeeList] = useState([]);
    const [feeMasterList, setFeeMasterList] = useState([]);

    const [fee, setFee] = useState({
        feeMasterId: "",
        classId: "",
        studentId: [],
        isEventForAllStudent: false,
        totalFee: "",
        installments: [{ fee: "", date: "" }],
    })
    const [savedInstallments, setSavedInstallments] = useState([]);
    const [installments, setInstallments] = useState([
        { fee: "", date: "" },
    ]);

    // Handle input change
    const handleFeeChange = (index, field, value) => {
        const newInstallments = [...installments];
        newInstallments[index][field] = value;
        setInstallments(newInstallments);
    };

    // Add new installment
    const handleAdd = () => {
        setInstallments([...installments, { fee: "", date: "" }]);
    };

    // Remove installment
    const handleRemove = (index) => {
        const newInstallments = installments.filter((_, i) => i !== index);
        setInstallments(newInstallments);
    };

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required("Class Name is required"),
        studentId: Yup.array(),
        totalFee: Yup.string().required("Total Fee is required"),
        feeMasterId: Yup.string().required("Academic Year is required"),
        isEventForAllStudent: Yup.boolean(),
        installments: Yup.array().of(
            Yup.object().shape({
                fee: Yup.string().required("Installment Fee is required"),
                date: Yup.string().required("Date is required"),
            })
        ),
    });
    useEffect(() => {
        // getStudentList();
        getFeeList();
        getAddClassList();
        getFeeMasterList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setAddClassList([]);
            setFeeMasterList([]);
            setStudentList([]);
            setFeeList([]);
            // setClassNameList([]);
        }
    }, []);
    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getSpeList = { classId: event.target.value };
        StudentService.getAllStudentById(userDetails.schooleId,
            getSpeList
        ).then((res) => {
            const studentDetails = res.map(res => {

                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            })
            setStudentList(studentDetails);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (status) => {
        if (status) {
            setFee({
                studentId: [],
                date: '',
                totalFee: '',
                classId: '',
                feeMasterId: '',
                installmentFee: '',
                isEventForAllStudent: false,

            })
        }

        setOpen(true);
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    const getFeeList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        FeeService.getAllFee(userDetails.schooleId).then((res) => {
            // For debugging
            console.log('Fee List:', res);
            res.forEach(fee => {
                if (fee.feeMasterId) {
                    console.log('Academic Year:', fee.feeMasterId.acadamicYear);
                }
            });
            setFeeList(res);
        }).catch((err) => {
            console.error('Error fetching fees:', err);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            setAddClassList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getFeeMasterList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        FeeMasterService.getAllFeeMaster(userDetails.schooleId).then((res) => {
            setFeeMasterList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editFee = (fee, status) => {
        const obj = JSON.parse(JSON.stringify(fee));

        // Set academicYear/feeMasterId
        obj.feeMasterId = fee.feeMasterId && fee.feeMasterId._id ? fee.feeMasterId._id : '';

        // Set studentId
        obj.studentId = fee.studentId
            ? [fee.studentId._id]   // ✅ wrap in array
            : [];

        // Set classId
        obj.classId = fee.classId ? fee.classId._id : '';

        // Set installments
        obj.installments = fee.istallmentId ? fee.istallmentId.map(inst => ({
            fee: inst.installmentFee,
            date: inst.installmentdate ? inst.installmentdate.split("T")[0] : ""
        })) : [{ fee: "", date: "" }];
        setInstallments(obj.installments);
        // ✅ Fix date format for date input
        if (fee.date) {
            obj.date = new Date(fee.date).toISOString().split("T")[0];
        }

        getStudentList({ target: { value: obj.classId } }, obj);
        getAddClassList();
        getFeeMasterList(); // Add this line to fetch academic years

        setFee(obj);
        if (status) {
            delete obj._id;
        }
        handleOpen(false);
    };

    const deleteFee = (feedelete) => {
        if (feedelete) {
            FeeService.deleteFee(feedelete).then((res) => {
                getFeeList();
            }).catch((err) => {
            });
        }
    };
    const formik = useFormik({
        initialValues: fee,


        enableReinitialize: true,
        validationSchema: validationSchema,

        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.installments = installments;
            if (fee._id) {
                FeeService.upadeFee(values).then((res) => {
                    handleClose();
                    getFeeList();
                    resetForm()
                    alert("Fee Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                FeeService.creteFee(values).then((res) => {
                    // Immediately refresh the list
                    getFeeList();
                    // Reset form data
                    resetForm();
                    // Reset installments if you're using them separately
                    setInstallments([{ fee: '', date: '' }]);
                    handleClose();
                    alert("Fee Added Successfully.");
                })
                    .catch((err) => {
                        alert(err.response.data.message || "Error adding fee");
                    })
            }

        },
    });
    const totalInstallments = installments.reduce(
        (sum, inst) => sum + Number(inst.fee || 0),
        0
    );
    return (

        <>
            <PageTitle title="Fee" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Set up fee structure
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                            <Table stickyHeader className="mb-0">
                                <TableHead >
                                    <TableRow>
                                        {tableHeaders.map(key => (
                                            <StyledTableCell key={key}>{key}</StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>




                                    {feeList.slice(pg * rpg, pg * rpg + rpg).map((fee) => (
                                        <TableRow key={fee._id}>
                                            <TableCell className="pl-3 fw-normal" >
                                                {fee.feeMasterId && typeof fee.feeMasterId === 'object'
                                                    ? fee.feeMasterId.acadamicYear
                                                    : (fee.academicYear || '')}
                                            </TableCell>

                                            {/* <TableCell className="pl-3 fw-normal" >{fee.classId ? fee.classId.className : ''}</TableCell> */}
                                            <TableCell className="pl-3 fw-normal" >{fee.classId ? fee.classId.className : ''}</TableCell>

                                            {/* <TableCell className="pl-3 fw-normal">
                                                                 {fee.isEventForAllStudent ?"All":  fee.studentId?.map((student, index) => (
                                                                     <span key={student._id || index}>
                                                                       {student.firstName} {student.lastName}
                                                                       {index < fee.studentId.length - 1 ? ", " : ""}
                                                                     </span>
                                                                   ))}
                                                               
                                                               </TableCell> */}
                                            <TableCell>
                                                {fee.studentId
                                                    ? `${fee.studentId.firstName} ${fee.studentId.lastName}`
                                                    : "All"}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal" >{fee.totalFee}</TableCell>
                                            <TableCell>
                                                {fee.istallmentId && fee.istallmentId.length > 0
                                                    ? fee.istallmentId.map(inst => dateAndTime(inst.installmentdate) + " - ₹" + inst.installmentFee).join(", ")
                                                    : "-"}
                                            </TableCell>
                                            {/* <TableCell>
        {fee.installmentId ? fee.installmentId.length : 0}
      </TableCell> */}

                                            {/* <TableCell className="pl-3 fw-normal" >{dateAndTime(fee.date)}</TableCell> */}

                                            <TableCell>
                                                {/* <EditIcon style={{ cursor: 'pointer' }} onClick={() => editStudent(student._id, student)} ></EditIcon> */}
                                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => editFee(fee)} >
                                                </EditIcon >
                                            </TableCell>
                                            <TableCell>
                                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteFee(fee)} />
                                            </TableCell>
                                            {/* <TableCell>
                                                <AddIcon style={{ cursor: 'pointer' }} onClick={() => editSpecialObservation(observation, true)} />
                                            </TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000]}
                            count={feeList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                PaperProps={{
                    style: {
                        width: '500px',
                        maxWidth: '100%',
                        margin: '0 auto',
                        maxHeight: '80vh',
                        overflow: 'hidden'
                    }
                }}>
                <DialogTitle>Set up fee structure</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ maxHeight: '60vh', overflowY: 'auto', width:'500px' }}>

                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Acadamic Year</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="feeMasterId"
                                label="Select Acadamic Year"
                                value={formik.values.feeMasterId}
                                onChange={formik.handleChange}
                                error={formik.touched.feeMasterId && Boolean(formik.errors.feeMasterId)}
                                helperText={formik.touched.feeMasterId && formik.errors.feeMasterId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {feeMasterList.map((feeMaster) => (
                                    <MenuItem key={feeMaster._id} value={feeMaster._id}>
                                        {feeMaster.acadamicYear}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"

                                value={formik.values.classId}
                                onChange={e => { formik.handleChange(e); getStudentList(e) }}
                                // onChange={formik.handleChange}

                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <div>

                            {formik.values.isEventForAllStudent}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isEventForAllStudent" id="terms"
                                            value={formik.values.isEventForAllStudent}
                                            checked={formik.values.isEventForAllStudent}
                                            onChange={formik.handleChange}
                                            error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                                            helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                                        />
                                    }
                                    label="For All Class Students"
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Any Concession For Special Student:</span>
                            </Grid>
                        </div>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="studentName-label">Student Name</InputLabel>
                            <Select
                                labelId="studentName-label"
                                id="studentName-select"
                                label="Student Name"
                                name="studentId"
                                multiple
                                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                                onChange={formik.handleChange}
                                // Customize how the selected values are displayed in the input
                                renderValue={(selected) => {
                                    // Find student names for the selected IDs
                                    const selectedNames = studentList
                                        .filter(({ _id }) => selected.includes(_id))
                                        .map(({ studentName }) => studentName);
                                    return selectedNames.join(", ");
                                }}
                            >
                                {studentList.map(({ _id, studentName }) => (
                                    <MenuItem key={_id} value={_id}>
                                        {studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth="true"

                            margin="dense"
                            id="totalFee"
                            name="totalFee"
                            label="Total Fee"
                            type="text"
                            variant="standard"
                            value={formik.values.totalFee}
                            onChange={formik.handleChange}
                            error={formik.touched.totalFee && Boolean(formik.errors.totalFee)}
                            helperText={formik.touched.totalFee && formik.errors.totalFee}
                        />
                        {/* <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="installmentFee"
                            name="installmentFee"
                            label="Installment Fee"
                            type="text"
                            variant="standard"
                            value={formik.values.installmentFee}
                            onChange={formik.handleChange}
                            error={formik.touched.installmentFee && Boolean(formik.errors.installmentFee)}
                            helperText={formik.touched.installmentFee && formik.errors.installmentFee}
                        />
                        <TextField InputProps={{ style: { width: 250 } }}
                            id="date"
                            name="date"
                            label="Select Date"
                            type="date"
                            value={formik.values.date}
                            onChange={formik.handleChange}
                            error={formik.touched.date && Boolean(formik.errors.date)}
                            helperText={formik.touched.date && formik.errors.date}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        /> */}

                        <Typography style={{ marginTop: 24, marginBottom: 8, fontWeight: 600 }}>Installments</Typography>
                        {installments.map((installment, index) => (
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                key={index}
                                style={{
                                    marginBottom: 10,
                                    width: '100%',
                                    margin: 0,
                                    paddingRight: '16px'
                                }}
                            >
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        label={`${index + 1}${getOrdinalSuffix(index + 1)} Instalment Fee`}
                                        value={installment.fee}
                                        onChange={(e) =>
                                            handleFeeChange(index, "fee", e.target.value)
                                        }
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        label="Due date"
                                        type="date"
                                        value={installment.date}
                                        onChange={(e) =>
                                            handleFeeChange(index, "date", e.target.value)
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', alignItems: 'center' }}>
                                    <IconButton
                                        color="primary"
                                        onClick={handleAdd}
                                        size="small"
                                        style={{
                                            backgroundColor: "#e3f2fd",
                                            width: '32px',
                                            height: '32px',
                                            padding: '4px'
                                        }}>
                                        <Add fontSize="small" />
                                    </IconButton>
                                    {installments.length > 1 && (
                                        <IconButton
                                            color="secondary"
                                            onClick={() => handleRemove(index)}
                                            size="small"
                                            style={{
                                                backgroundColor: "#ffebee",
                                                width: '32px',
                                                height: '32px',
                                                padding: '4px'
                                            }}
                                        >
                                            <Remove fontSize="small" />
                                        </IconButton>
                                    )}
                                </Grid>
                            </Grid>
                        ))}
                        <Typography
                            variant="subtitle1"
                            style={{ marginTop: 16, fontWeight: "bold" }}
                        >
                            Total Fee Payable: {installments.reduce((sum, inst) => sum + Number(inst.fee || 0), 0)}
                        </Typography>
                        {totalInstallments !== Number(formik.values.totalFee) && (
                            <Typography color="error" variant="body2" style={{ marginTop: 4 }}>
                                ⚠️ Installments don’t match Total Fee ({totalInstallments} / {formik.values.totalFee})
                            </Typography>
                        )}
                    </DialogContent>

                    <DialogActions style={{ 
                        position: 'sticky', 
                        bottom: 0, 
                        background: '#fff', 
                        borderTop: '1px solid #eee',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        padding: '16px 24px'
                    }}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" variant="contained"
                            color="primary">Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
            {/* <Table>
      <TableHead>
        <TableRow>
          <TableCell>Installment #</TableCell>
          <TableCell>Fee</TableCell>
          <TableCell>Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {savedInstallments.map((inst, i) => (
          <TableRow key={i}>
            <TableCell>{i + 1}</TableCell>
            <TableCell>{inst.fee}</TableCell>
            <TableCell>{inst.date}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table> */}

        </>
    );
}


